import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Landing from './Landing';

// D5.1 — Give each secondary URL its own title + description so crawlers don't
// see duplicates of the homepage listing. The visible page is still the full
// Landing (so direct links deep-scroll to the right anchor).

const META = {
  '/pricing': {
    title: 'Fencepost Pricing — $9.99/mo, one plan, everything unlocked',
    description: 'One honest price for Fencepost. $9.99/month unlocks livestock, poultry, garden, reports, weather alerts, and more. 7-day free trial, 30-day money-back guarantee on monthly plans.',
    anchor: 'pricing',
  },
  '/features': {
    title: 'Fencepost Features — Livestock, Garden, Poultry & Reports in One App',
    description: 'See every feature in Fencepost: livestock and poultry tracking, garden planner, milk and egg logs, breeding and vet records, grant-ready PDF reports, CSV exports, weather alerts, and farm notebook.',
    anchor: 'features',
  },
  '/about': {
    title: 'About Fencepost — Built by a Small-Farm Owner in Tombstone, AZ',
    description: 'Fencepost was built by Ally Kelley on her own small farm in Tombstone, Arizona, because nothing out there kept track of the whole operation the way a homesteader actually needs.',
    anchor: 'about',
  },
  '/customers': {
    title: 'Fencepost Users — What Early Homesteaders Are Saying',
    description: 'Real, verbatim quotes from early Fencepost users on their own small farms. Verified, with permission.',
    anchor: 'testimonials',
  },
};

const MetaRoute = () => {
  const { pathname } = useLocation();
  const meta = META[pathname];

  useEffect(() => {
    if (!meta) return;
    const originalTitle = document.title;
    document.title = meta.title;
    let desc = document.querySelector('meta[name="description"]');
    const originalDesc = desc?.getAttribute('content');
    if (desc) desc.setAttribute('content', meta.description);
    // Also OG + Twitter description for crawlers that follow it
    const ogDesc = document.querySelector('meta[property="og:description"]');
    const originalOg = ogDesc?.getAttribute('content');
    if (ogDesc) ogDesc.setAttribute('content', meta.description);
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const originalOgTitle = ogTitle?.getAttribute('content');
    if (ogTitle) ogTitle.setAttribute('content', meta.title);

    // Deep-scroll to the matching homepage section once hydrated.
    const t = setTimeout(() => {
      const el = document.getElementById(meta.anchor);
      if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' });
    }, 80);

    return () => {
      clearTimeout(t);
      document.title = originalTitle;
      if (desc && originalDesc != null) desc.setAttribute('content', originalDesc);
      if (ogDesc && originalOg != null) ogDesc.setAttribute('content', originalOg);
      if (ogTitle && originalOgTitle != null) ogTitle.setAttribute('content', originalOgTitle);
    };
  }, [pathname, meta]);

  return <Landing />;
};

export default MetaRoute;
